var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    fill: "#F3F6F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4139_32832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51209 17.3501C7.51153 19.4506 8.04253 21.5016 9.05221 23.3094L7.41553 29.4859L13.531 27.8285C15.2225 28.7803 17.1177 29.279 19.0435 29.2791H19.0486C25.4062 29.2791 30.5815 23.9319 30.5842 17.3595C30.5855 14.1748 29.3866 11.18 27.2084 8.92689C25.0306 6.67398 22.1342 5.43261 19.0481 5.43115C12.6897 5.43115 7.51481 10.7781 7.51218 17.3501",
    fill: "url(#paint0_linear_4139_32832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10031 17.3465C7.09966 19.5226 7.64969 21.6469 8.69537 23.5194L7 29.9173L13.3348 28.2006C15.0802 29.1842 17.0454 29.7028 19.0451 29.7036H19.0502C25.636 29.7036 30.9972 24.1641 31 17.3564C31.0011 14.0572 29.7591 10.9547 27.5031 8.62093C25.2468 6.2874 22.2468 5.00136 19.0502 5C12.4634 5 7.10294 10.5388 7.10031 17.3465ZM10.8729 23.1969L10.6364 22.8088C9.64206 21.1747 9.11725 19.2863 9.118 17.3473C9.12006 11.6889 13.5754 7.08527 19.054 7.08527C21.7071 7.08643 24.2005 8.15543 26.0759 10.095C27.9512 12.0347 28.9831 14.6132 28.9824 17.3556C28.98 23.0141 24.5245 27.6182 19.0502 27.6182H19.0463C17.2638 27.6172 15.5157 27.1225 13.9911 26.1875L13.6283 25.9651L9.86912 26.9838L10.8729 23.1969Z",
    fill: "url(#paint1_linear_4139_32832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0633 12.1849C15.8397 11.6711 15.6042 11.6607 15.3915 11.6517C15.2173 11.644 15.0182 11.6445 14.8193 11.6445C14.6202 11.6445 14.2966 11.722 14.0232 12.0306C13.7494 12.3395 12.978 13.086 12.978 14.6043C12.978 16.1227 14.048 17.5901 14.1972 17.7962C14.3465 18.0019 16.2627 21.2174 19.2976 22.4544C21.8199 23.4824 22.3332 23.278 22.8806 23.2264C23.4281 23.1751 24.6472 22.4801 24.8959 21.7595C25.1448 21.0389 25.1448 20.4213 25.0702 20.2922C24.9956 20.1636 24.7964 20.0864 24.4978 19.9321C24.1992 19.7778 22.7312 19.0312 22.4576 18.9282C22.1838 18.8253 21.9848 18.7739 21.7857 19.0829C21.5865 19.3914 21.0147 20.0864 20.8405 20.2922C20.6664 20.4985 20.4921 20.5242 20.1936 20.3698C19.8948 20.215 18.9332 19.8895 17.7924 18.8382C16.9047 18.0202 16.3055 17.01 16.1313 16.701C15.9571 16.3925 16.1127 16.2253 16.2624 16.0715C16.3965 15.9332 16.5611 15.7111 16.7105 15.531C16.8594 15.3507 16.9091 15.2222 17.0086 15.0163C17.1083 14.8103 17.0584 14.6301 16.9839 14.4757C16.9091 14.3214 16.3288 12.7951 16.0633 12.1849Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4139_32832",
    x1: 1165.85,
    y1: 2410.91,
    x2: 1165.85,
    y2: 5.43115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#247D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D82F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4139_32832",
    x1: 1207,
    y1: 2496.73,
    x2: 1207,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4139_32832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white",
    transform: "translate(7 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.67041101a00ae2db1ce2e01339bb64f0.svg";
export { ForwardRef as ReactComponent };